import { Navigator } from "common/components/Navigator";
import { useAppSelector } from "common/hooks/storeHooks";
import { userAclCheck } from "common/selectors/user.selectors";
import { useEffect, useState } from "react";

export const NavigatorListener: React.FC = () => {
  // Local State
  const [showMenu, setShowMenu] = useState(false);

  // Selectors
  const hasPermission = useAppSelector((state) => userAclCheck(state, { resource: "flags", permission: "navigator" }));

  // Methods
  const handleKeyDown = (event: KeyboardEvent) => {
    // Check for CMD + K (or Ctrl + K on Windows/Linux)
    if ((event.metaKey || event.ctrlKey) && event.key === "k") {
      event.preventDefault();
      setShowMenu((prev) => !prev);
    }
    // Check for ESC key
    else if (event.key === "Escape") {
      event.preventDefault();
      // Close the menu
      setShowMenu(false);
    }
  };

  useEffect(() => {
    if (!hasPermission) return;
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [hasPermission]);

  if (!showMenu) return null;

  return <Navigator close={() => setShowMenu(false)} />;
};
